import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useOnMediaQuery from '../../../ui/hooks/useOnMediaQuery'
import { FilterContext } from '../../../ui/contexts/FilterContext'
import isArrayEqual from '../../../../utils/isArrayEqual'

import { uxEvent } from '../../../../flux/actions/ux'
import { selectCurrentCategories } from '../../../../flux/selectors/ux'
import { selectCategories } from '../../../../flux/selectors/categories'
import CategoriesDropdown from '../CategoriesDropdown'
import CategoriesDialog from '../CategoriesDialog'

const CategoriesFilter = () => {
  const dispatch = useDispatch()
  const {
    isFilterOpen, setFilterOpen,
    selectedCategories, setSelectedCategories,
  } = useContext(FilterContext)
  const activeCategories = useSelector(selectCurrentCategories)
  const categoryList = useSelector(selectCategories)
  const [isDesktopMediaQuery, setDesktopMediaQuery] = React.useState(false)

  React.useEffect(() => {
    setSelectedCategories(activeCategories)
  }, [activeCategories])

  useOnMediaQuery('only screen and (min-width: 1024px)', status => {
    if (status !== isDesktopMediaQuery) {
      setDesktopMediaQuery(status)
    }
  })

  const onClearFilterClick = () => {
    dispatch(uxEvent({
      name: 'click',
      target: 'CategoriesFilter/Apply',
      params: { categories: [] },
    }))
    setFilterOpen(false)
  }

  const onApplyFilterClick = () => {
    if (!isArrayEqual(selectedCategories, activeCategories)) {
      dispatch(uxEvent({
        name: 'click',
        target: 'CategoriesFilter/Apply',
        params: { categories: selectedCategories },
      }))
    }
    setFilterOpen(false)
  }

  const onCategoryListItemClick = category => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories([...selectedCategories.filter(x => x !== category)])
    } else {
      setSelectedCategories([...selectedCategories, category])
    }
  }

  if (!isFilterOpen) return null
  if (categoryList && categoryList.length > 0) {
    return isDesktopMediaQuery ? (
      <CategoriesDropdown
        isOpen={isFilterOpen}
        selectedCategories={selectedCategories}
        onApplyFilterClick={onApplyFilterClick}
        onClearFilterClick={onClearFilterClick}
        onCategoryListItemClick={onCategoryListItemClick}
      />
    ) : (
      <CategoriesDialog
        isOpen={isFilterOpen}
        selectedCategories={selectedCategories}
        onClearFilterClick={onClearFilterClick}
        onApplyFilterClick={onApplyFilterClick}
        onCategoryListItemClick={onCategoryListItemClick}
      />
    )
  }

  return null
}

CategoriesFilter.displayName = 'CategoriesFilter'
CategoriesFilter.whyDidYouRender = true

export default CategoriesFilter
